<!--floorCard 楼宇卡片-->
<template>
  <div class="right-table">
    <el-input style="width: 360px;" size="mini" placeholder="输入设备名称、设备ID、回路编号搜索" suffix-icon="el-icon-search"
      v-model="filterText2"> </el-input>
    <div class="num_box">
      <div class="t">
        <div class="num">1020</div>
        <div class="e">设备总数</div>
      </div>
      <div class="line"></div>
      <div class="t">
        <div class="num">864</div>
        <div class="e">设备开启数</div>
      </div>
      <div class="line"></div>
      <div class="t">
        <div class="num">278</div>
        <div class="e">设备关闭数</div>
      </div>
      <div class="line"></div>
      <div class="t">
        <div class="num">26</div>
        <div class="e">设备故障数</div>
      </div>
    </div>
    <div class="top-table">
      <div class="titles">
        <div class="leftd"><span>开启：</span>
          <div class="l1"></div><span>关闭：</span>
          <div class="l2"></div><span>故障：</span>
          <div class="l3"></div>
        </div>
        <div class="rightd" @click="goUrl('/floorSpot')">
          <span style="font-size: 12px;padding: 2px 4px;  ">图片</span>
          <span style="font-size: 12px;padding: 2px 4px; background-color: #0D75D4; color: #fff;">卡片</span>
        </div>
      </div>

      <div class="center">
        <div class="popo_box" v-for="(e,i) in list" :key="i">
          <div class="a" :class="{'active2': !e.e}" :style="{backgroundColor:e.e?e.color:'#e6e6e6'}">
            {{(i+1)+e.a}}
          </div>
          <div class="b">
            <div class="n">设备编号：</div>zm167
          </div>
          <div class="b">
            <div class="n">设备位置：</div>A栋A座1楼
          </div>
          <div class="b">
            <div class="n">运行时长：</div>12 h
          </div>
          <div class="e"><el-switch class="sw" v-model="e.e" size="mini" active-color="#13ce66" inactive-color="#ccc">
            </el-switch>
            <img class="swImg" v-if="e.e" src="./img/lg.png">
            <img class="swImg" v-else src="./img/la.png">
            <div class="swUl" :class="{'active': e.e}">
              <div class="swLi"></div>
              <div class="swLi"></div>
              <div class="swLi"></div>
              <div class="swLi"></div>
              <div class="swLi"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    //inject: ['reload'],
    components: {
      elIconBtn
    },
    data () {
      return {
        value1: true,
        heights: Math.round((document.getElementById('app').clientHeight)*0.55),
        defaultProps: {
          children: 'children',
          label: 'typeName'
        },
        filterText: "",
        filterText2: "",
        getEntityTypeList: this.$store.unitStore.state.getEntityTypeList,
        list: [{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: true,
          color: '#368ed9',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: true,
          color: '#FF7A2F',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: false,
          color: '#FF7A2F',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: true,
          color: '#FF7A2F',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: true,
          color: '#368ed9',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: true,
          color: '#368ed9',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: true,
          color: '#FF7A2F',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: false,
          color: '#FF7A2F',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: false,
          color: '#FF7A2F',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: true,
          color: '#368ed9',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: false,
          color: '#368ed9',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: true,
          color: '#368ed9',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: false,
          color: '#368ed9',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: true,
          color: '#FF7A2F',
        },{
          a: '#照明回路',
          b: 'zm167',
          c: 'A栋A座1楼',
          d: '12 h',
          e: false,
          color: '#368ed9',
        },],
        typeEnum: 0,

      }
    },


    methods: {
      goUrl (v) {
        // this.$router.push(v)
        this.$parent.goUrl(1);
      },
      checkItem (data) {

      },
      //筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.typeName.indexOf(value)!==-1;
      },


    }
  }
</script>

<style scoped lang="scss">
  .swUl {
    display: flex;
    border-radius: 5px;
    overflow: hidden;
    margin-right: 10px;

    .swLi {
      background: #ccc;
      width: 19px;
      height: 16px;
      margin-right: 1px;
    }

    .swLi:nth-child(n+4) {
      background: #e6e6e6;
    }
  }

  .active .swLi {
    background: #1890FF;
  }

  .swImg {
    width: 15px;
    height: 15px;
    margin-right: 4px;
    margin-left: 12px;
  }

  .popo_box {
    border-radius: 4px;
    background: #FAFAFA;
    width: 188px;
    height: 144px;
    box-sizing: border-box;
    border: 1px solid #E6E6E6;
    margin-right: 8px;
    margin-top: 8px;

    .e {
      display: flex;
      align-items: center;
      margin: 6px 0;
      padding-left: 4px;

      .sw {
        transform: scale(.6);
      }
    }

    .a {
      background: #368ED9;
      color: #FFF;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 14px;
      height: 34px;
      line-height: 34px;
      margin-bottom: 9px;
      padding-left: 12px;
    }

    .active2 {
      color: #666;
    }

    .b {
      display: flex;
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 12px;
      padding: 0px 12px;
      margin-top: 6px;

      .n {
        color: #666;
        font-family: Microsoft YaHei;
        font-weight: regular;
        font-size: 12px;

      }

    }
  }

  .titles {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 8px;
    color: #666666;
    font-family: Microsoft YaHei;
    font-weight: regular;
    font-size: 12px;

    .l1 {
      border-radius: 4px;
      background: #368ED9;
      width: 24px;
      height: 24px;
      margin-right: 20px;
    }

    .l2 {
      border-radius: 4px;
      background: #E6E6E6;
      width: 24px;
      height: 24px;
      margin-right: 20px;
    }

    .l3 {
      border-radius: 4px;
      background: #FF7A2F;
      width: 24px;
      height: 24px;
      margin-right: 20px;
    }

    .rightd {
      border-radius: 4px;
      background: #FFF;
      border: 1px solid #E6E6E6;
      display: flex;
      align-items: center;
      cursor: pointer;
      overflow: hidden;
    }

    .leftd {
      display: flex;
      align-items: center;

      img {
        margin-right: 20px;
      }
    }
  }

  .name-wrapper {
    position: absolute;
    width: 50px;
  }

  .spot img {
    position: absolute;
    width: .5rem;
    height: .5rem;
    left: 0;
    top: 0;
  }

  .center {
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }

  .num_box {
    display: flex;
    border-radius: 4px;
    border: 1px solid #EBEBEB;
    justify-content: space-around;
    margin-top: 20px;
    height: 66px;
    align-items: center;

    .line {
      width: 1px;
      height: 42px;
      background-color: #EBEBEB;
    }

    .num {
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 2px;
      text-align: center;
    }

    .e {
      color: #666;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 12px;

    }
  }

  .custom-tree-node {
    display: flex;
    width: calc(100% - 51px);

    .tt {
      padding: 0px 5px;
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 14px;

    }

    .aaa {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 12px;
      align-items: center;
    }
  }

  .archiverstype {
    .con {
      width: 100%;
      min-height: 100%;
      box-sizing: border-box;
      display: flex;
      padding: 8px;

      .left-tree {
        width: 224px;
        min-height: 100%;
        background-color: #fff;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 12px;
        padding-top: 20px;

        .btns {
          margin-top: 20px;
          color: #1A1A1A;
          font-family: Microsoft YaHei;
          font-weight: regular;
          font-size: 14px;
          display: flex;
          justify-content: space-between;

          .txt {
            font-family: Microsoft YaHei;
            font-weight: regular;
            font-size: 12px;
            padding-right: 8px;
          }

          .i {
            color: #0D75D4;
            font-family: Microsoft YaHei;
            font-weight: regular;
            font-size: 12px;
          }
        }

        /deep/.el-button {
          padding: 6px 11px !important;
        }
      }

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }


    }
  }

  .right-table {
    width: calc(100% - 232px);
    min-height: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px;
  }
</style>
<style>
  .el-scrollbar__wrap {
    overflow: auto;
  }

  .el-popover {
    padding: 0 !important;
    border-radius: 4px;
    overflow: hidden;
  }
</style>